export default [
  {
    id: 0,
    email: "abc@gmail.com",
    password: "abc123",
  },
];
